const utils = {
  getTerminal() {// 判断终端是ios还是android
    var u = window.navigator.userAgent;
    var terminal = 'pc';
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // android终端或者uc浏览器
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) terminal = 'android';
    if (isIOS) terminal = 'ios';
    return terminal;
  },
  isWeixin() {// 判断终端是不是微信
    var ua = window.navigator.userAgent.toLowerCase();
    return !!ua.match(/micromessenger/i) || !!ua.match(/_sq_/i);
  },
  clearCache(callback) {// 清除缓存
    var href = window.location.href;
    if(href.indexOf("stamp=") == -1) {
      var urls = href.split("?");
      var stamp = new Date().getTime();
      if(urls.length>1){
        window.location.replace(href + "&stamp=" + stamp);
      }else{
        window.location.replace(href + "?stamp=" + stamp);
      }
    }else{
      callback && callback();
    }
  },
  isEnumerateDevicesSupported() {
    // 检查 navigator.mediaDevices 对象是否存在
    if (window.navigator.mediaDevices === undefined) {
        return false;
    }
    // 检查 navigator.mediaDevices.enumerateDevices 是否为函数
    return typeof navigator.mediaDevices.enumerateDevices === 'function';
  },
  getQueryString: function (name) { //截取参数
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return r[2]
    return ''
  },
  formatNumber: function (n) { //时间补0
    n = n.toString()
    return n[1] ? n : '0' + n
  },
  isEmpty: function (obj) { //是否为空
    if (typeof obj == "undefined" || !obj && typeof obj != "undefined" && obj != 0) {
      return false;
    }
    let arr = Object.keys(obj);
    if (arr.length) {
      return true;
    } else {
      return false;
    }
  },
  deepClone: function (obj) { //deep拷贝
    return JSON.parse(JSON.stringify(obj));
  },
  throttle: function (fn, delay, atleast) { //节流
    var timer = null;
    var previous = null;
    return function () {
      var now = +new Date();
      if (!previous) previous = now;
      if (atleast && now - previous > atleast) {
        fn(this);
        previous = now;
        clearTimeout(timer);
      } else {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn(this);
          previous = null;
        }, delay);
      }
    }
  },
  parseTime: function (time, cFormat) { //时间格式化
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}/{m}/{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },

  // 筛选抢购中的时间: 如果是抢购中 state = 2，则返回当前抢购时间的索引值
  returnTimeIndex: function (arr) {
    let index = 0;
    if(arr && arr.length > 0){
      for (let i in arr) {
        if (arr[i].state == 2) {  // 如果有抢购中的时间段，就返回该时间段的index
          index = i;
          break;
        }else if(arr[arr.length-1].state == 3){   // 如果全部都已经抢购完，则返回最后一个时间段的index
          index = arr.length-1;
          break;
        }
      }
      return parseInt(index)
    }
  }
}
export default utils